import React, { FC, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox, confirm, notification } from 'src/common';
import { useMutation } from '@apollo/client';
import { IApiCompany } from 'src/models/company/types';
import modalStyles from 'src/common/Modal/index.module.scss';
import styles from './index.module.scss';
import { UPDATE_COMPANY_ENABLED } from 'src/models/admin/CompanyUsers/queries';
interface DeactivateCompanyProps {
  companyId: string;
  enabled: boolean;
}

export const DeactivateCompany: FC<DeactivateCompanyProps> = props => {
  const { companyId, enabled } = props;
  const [companyEnabled, setEnabled] = useState(enabled);
  const { t } = useTranslation();

  const [updateCompanyEnabled] = useMutation<
    { updateCompanyEnabled: IApiCompany },
    { companyId: string; enabled: boolean }
  >(UPDATE_COMPANY_ENABLED);

  const updateCompany = useCallback(
    (checked: boolean) => {
      confirm.confirm({
        title: t('AdminPage.confirmTitle'),
        okText: t('Common.yes'),
        cancelText: t('Common.no'),
        className: modalStyles.confirmModal,
        centered: true,
        onOk() {
          updateCompanyEnabled({ variables: { companyId, enabled: !checked } })
            .then(r => {
              setEnabled(r.data?.updateCompanyEnabled?.enabled as boolean);
            })
            .catch(() => {
              notification.error({
                message: t('Common.unknownError'),
                description: t('Common.unknownErrorDesc')
              });
            });
        }
      });
    },
    [companyId, t, updateCompanyEnabled]
  );

  // Checkbox represents "Deactivated" which is reverse of the backend field enabled so we have to reverse value back and forth
  return (
    <Checkbox
      className={styles.checkbox}
      checked={!companyEnabled}
      value={!companyEnabled}
      onChange={e => updateCompany(e.target.checked)}
    />
  );
};
